import { Article, CodeBlock, Icon } from '@phosphor-icons/react';
import {
  FileListType,
  ArtifactType,
  ProgrammingLanguage,
  ProgrammingLanguageOptions,
} from 'src/types';

export const FileIconsSet: Partial<Record<ArtifactType | FileListType, Icon>> =
  {
    [ArtifactType.TEXT]: Article,
    [ArtifactType.CODE]: CodeBlock,
  };

export const EditorTypesIconsSet: Record<ArtifactType, Icon> = {
  [ArtifactType.TEXT]: Article,
  [ArtifactType.CODE]: CodeBlock,
};

export const PROGRAMMING_LANGUAGES: Array<{
  language: ProgrammingLanguage;
  label: string;
}> = [
  {
    language: 'typescript',
    label: 'TypeScript',
  },
  {
    language: 'javascript',
    label: 'JavaScript',
  },
  {
    language: 'cpp',
    label: 'C++',
  },
  {
    language: 'java',
    label: 'Java',
  },
  {
    language: 'php',
    label: 'PHP',
  },
  {
    language: 'python',
    label: 'Python',
  },
  {
    language: 'html',
    label: 'HTML',
  },
  {
    language: 'sql',
    label: 'SQL',
  },
  {
    language: 'json',
    label: 'JSON',
  },
  {
    language: 'rust',
    label: 'Rust',
  },
  {
    language: 'xml',
    label: 'XML',
  },
  {
    language: 'clojure',
    label: 'Clojure',
  },
  {
    language: 'csharp',
    label: 'C#',
  },
  {
    language: 'css',
    label: 'CSS',
  },
  {
    language: 'other',
    label: 'Other',
  },
];

export const DEFAULT_THREAD_TITLE = 'Untitled document';

const CODE_CONVERTIBLE_LANGUAGES = [
  'javascript',
  'typescript',
  'python',
  'php',
  'java',
  'csharp',
  'cpp',
  'rust',
] as ProgrammingLanguageOptions[];

export const CONVERTIBLE_LANGUAGES: Record<
  ProgrammingLanguage,
  ProgrammingLanguage[]
> = {
  javascript: CODE_CONVERTIBLE_LANGUAGES,
  typescript: CODE_CONVERTIBLE_LANGUAGES,
  python: CODE_CONVERTIBLE_LANGUAGES,
  php: CODE_CONVERTIBLE_LANGUAGES,
  java: CODE_CONVERTIBLE_LANGUAGES,
  csharp: CODE_CONVERTIBLE_LANGUAGES,
  cpp: CODE_CONVERTIBLE_LANGUAGES,
  rust: CODE_CONVERTIBLE_LANGUAGES,
  html: ['xml', 'json'],
  xml: ['html', 'json'],
  json: ['xml', 'sql'],
  sql: ['json'],
  css: [],
  scss: [],
  clojure: ['java', 'javascript'],
  other: [
    ...CODE_CONVERTIBLE_LANGUAGES,
    'html',
    'xml',
    'json',
    'sql',
    'css',
    'scss',
    'clojure',
  ],
};
